import React, { useState, useEffect, useContext, Fragment } from 'react';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Layout from 'components/sales/layout/layout';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import AddPromoters from 'components/brandActivation/addPromoters/addPromoters';
import DivLayout from 'components/sales/divLayout/divLayout';
import './vendorAll.css'
const VendorAllocation = ({
  getVendorList,
  vendorList,
  match,
  history,
  postVendor,
  viewVendorDetails = null,
  vendorDetails = null,
}) => {
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [isVendorAllocated, setIsVendorAllocated] = useState(false);
  const [vendorId, setVendorId] = useState('');
  const [formData, setFormData] = useState({
    camp_id: match?.params?.id,
    vendor_id: '',
    promoters: [],
  });

  useEffect(() => {
    (async () => {
      const allocated =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].is_vendor_allocated;
      setIsVendorAllocated(allocated);

      const id =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'))[0].vendor_id;
      setVendorId(id);
    })();
  }, []);

  useEffect(() => {
    setSiteId(match.params.id);
    if (siteId) {
      if (getVendorList !== null) {
        (async () => {
          setIsLoading(true);
          await getVendorList();
          setIsLoading(false);
        })();
      }
    }
  }, [getVendorList, siteId]);

  useEffect(() => {
    (async () => {
      if (isVendorAllocated && vendorId) {
        await viewVendorDetails(vendorId, match.params.id);
      }
    })();
  }, [isVendorAllocated, vendorId]);

  useEffect(() => {
    setListData(vendorList);
  }, [vendorList]);

  const handleModalHide = () => setIsModal(false);

  const handleSubmit = async () => {
    (async () => {
      if (
        formData?.camp_id !== null &&
        formData.vendor_id != null &&
        formData?.promoters?.length > 0
      ) {
        setIsFiled(false);
        const res = await postVendor(formData);
        if (res) {
          setIsModal(true);
        }
      } else {
        setIsFiled(true);
        setIsModal(false);
      }
    })();
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submit}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.vendorAllocation}
      isGoback
      Buttons={isVendorAllocated ? () => {} : headerBtns}
      isLoading={isLoading}
      className={isFiled ? 'requiredFileds' : ''}
      linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp/${match?.params?.siteId}`}
    >
      <FormSection
        title={
          vendorDetails && vendorDetails.length > 0
            ? localization.vendorDetails
            : localization.vendorAllocation
        }
      >
        {isVendorAllocated ? (
          <Fragment>
            <div className="details-listing">
              <DivLayout
                heading={localization.vendorName}
                data={
                  vendorDetails && vendorDetails.name
                    ? vendorDetails && vendorDetails.name
                    : localization.na
                }
              />

              <DivLayout
                heading={localization.vendorFirm}
                data={
                  vendorDetails && vendorDetails.firm
                    ? vendorDetails && vendorDetails.firm
                    : localization.na
                }
              />
            </div>
            {vendorDetails &&
              vendorDetails.promoters &&
              vendorDetails.promoters.length > 0 && (
                <Fragment>
                  <FormSection title={'Promoters'}>
                    {vendorDetails.promoters.map((obj) => {
                      return (
                        <div className="details-listing">
                          <DivLayout
                            heading={localization.name}
                            data={
                              obj && obj.name
                                ? obj && obj.name
                                : localization.na
                            }
                          />

                          <DivLayout
                            heading={localization.designation}
                            data={
                              obj && obj.designation
                                ? obj && obj.designation
                                : localization.na
                            }
                          />
                        </div>
                      );
                    })}
                  </FormSection>
                </Fragment>
              )}
          </Fragment>
        ) : (
          <Fragment>
            <DropDownInput
              data={listData}
              label={localization.vendorAllocation}
              required
              isStarRequired={true}
              errorMsg={localization.mandatory}
              getIdValue={(val) => {
                setFormData({ ...formData, vendor_id: val.id });
              }}
            />
            <AddPromoters
              handleValue={(val) =>
                setFormData({ ...formData, promoters: val?.promoters })
              }
              match={match.params.id}
            />
          </Fragment>
        )}
      </FormSection>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.vendorAllocateSuccess}</h5>
         
          <Link
            to={`${baseUrl}/brand-activation/conduct-camp/camp/${match?.params?.siteId}`}
            className="btn align-btn  btn-primary mb-4"
          >
             <b className="continue_btn">
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
            </b>
          </Link>
         
        </div>

      </ModalPop>
      
    </Layout>
  );
};

export default VendorAllocation;
